import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class SendDataService {
  constructor(private http: HttpClient) {}

  public post(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/send-data`;
    return this.http.post(url, { params });
  }

  public delete(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/send-data`;
    return this.http.delete(url, { params });
  }
}
